import React from 'react';
import RxOrderContainer from "../../containers/RxOrder";

interface Props {
    meganetColorDensityMappingId: number | undefined,
}

export default ((props) => {
    const rxOrderContainer = RxOrderContainer.useContainer();
    const color = rxOrderContainer.getColorByColorDensityMappingId(props.meganetColorDensityMappingId);

    return (
        <>
            {color ? color.colorTypeName : '--'}
        </>
    );
}) as React.FC<Props>;
